
import React, { useState } from 'react';
import { Container, Typography, Grid, Button } from '@mui/material';

const Translation = ({ word, translations, onNext }) => {
  const [error, setError] = useState(false);

  // Find the correct translation from the list
  const correctAnswer = translations[word];

  const handleSelection = (answer) => {
    if (answer === correctAnswer) {
      setError(false);
      onNext();
    } else {
      setError(true);
    }
  };

  return (
    <Container maxWidth="sm" style={{ marginTop: '20px', textAlign: 'center' }}>
      <Typography variant="h5" gutterBottom>
        ترجم هذه الكلمة
      </Typography>
      <Typography variant="body1" gutterBottom style={{ marginBottom: '20px', color: 'purple' }}>
        {word}
      </Typography>
      <Grid container spacing={2}>
        {Object.values(translations).map((translation, index) => (
          <Grid item xs={6} key={index}>
            <Button variant="outlined" fullWidth onClick={() => handleSelection(translation)}>
              {translation}
            </Button>
          </Grid>
        ))}
      </Grid>
      {error && (
        <Typography variant="body1" style={{ color: 'red', marginTop: '20px' }}>
          خطأ حاول مرة أخرى
        </Typography>
      )}
    </Container>
  );
};

export default Translation;
